import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import ContentIntelligenceWrapper from "@components/layouts/contentIntelligenceWrapper";

export default function ContentIntelligenceHome(): ReactElement {
    return (
        <ContentIntelligenceWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="CMS"
                    domain="ContentIntelligence.com"
                />
            </div>
        </ContentIntelligenceWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
